"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function WhyChooseUs() {
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const reasons = [{
    id: 1,
    text: "Punctual and Reliable Service"
  }, {
    id: 2,
    text: "Discreet and Privacy-Focused"
  }, {
    id: 3,
    text: "High-Quality Luxury Vehicles"
  }, {
    id: 4,
    text: "Professional and Experienced Drivers"
  }];
  return <section id="why-choose-us" className="dark bg-background text-foreground section-padding relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={listRef} className="space-y-8">
            <h2 className="font-display text-4xl lg:text-5xl font-bold mb-8">
              Why Choose Us
            </h2>
            <ul className="space-y-6">
              {reasons.map((reason, i) => <li key={reason.id} data-index={i} className={`flex items-start gap-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${listVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} style={{
              transitionDelay: listVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-secondary/20 flex items-center justify-center mt-1">
                    <Check className="w-5 h-5 text-secondary" />
                  </div>
                  <span className="text-lg text-foreground/90 leading-relaxed">
                    {reason.text}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-0 lg:h-[70%]">
            <Separator orientation="vertical" className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${listVisible ? "opacity-100 h-full" : "opacity-0 h-0"}`} style={{
            transitionDelay: listVisible ? "400ms" : "0ms"
          }} />
          </div>

          {}
          <div ref={textRef} className={`relative glass-effect p-8 lg:p-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="absolute inset-0 opacity-5 bg-cover bg-center bg-no-repeat rounded-lg pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/perforated_leather_texture.png)]" aria-hidden="true" />

            <div className="relative z-10">
              <p className="text-lg lg:text-xl leading-relaxed text-foreground/90 font-light">At Phoenix Enterprises Limousine Service we redefine luxury transportation in Los Angeles. Our fleet of premium black cars and SUVs, combined with our team of professional chauffeurs, ensures every journey is executed with precision, comfort, and absolute discretion. Whether you need airport transfers, VIP transportation, or hourly bookings for special events, we deliver an unparalleled experience that reflects your success and values your time.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}